module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/theme-modern-3-d8c7e0e20d76bd20165ff8d5db592831.webp";